'use es6';

import { useEffect } from 'react';
import HubActions from 'AdsUI/actions/HubAttributesActions';
import { COUPON_CAMPAIGN_KEY } from 'AdsUI/data/HubAttributesData';
export default ((dispatch, {
  adsCampaign
}) => {
  return useEffect(() => {
    if (!adsCampaign) {
      return;
    }

    dispatch(HubActions.save({
      key: COUPON_CAMPAIGN_KEY,
      value: true
    }));
  }, [adsCampaign, dispatch]);
});